import CognitoService from './cognito.service'
import AwsAmplifyModule from '../awsAmplify/awsAmplify'

export default angular.module('app.services.cognito', [AwsAmplifyModule.name])
  .service('cognitoService', CognitoService)
